// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"72":"0f49a0ac","179":"35d57546","273":"bca5415f","292":"86a02498","687":"da1e57c8","715":"93526cce","923":"369cd492","954":"787f6361"}[chunkId] + ".css";
};